import FastMarquee from "react-fast-marquee";
import { useLanguage } from "@/i18n/LanguageContext";

export const Marquee = () => {
    const { t } = useLanguage();

    return (
        <div
            className="relative border-y border-white/5 py-8 md:py-10 overflow-hidden"
            data-testid="editorial-marquee"
            aria-hidden="true"
        >
            <FastMarquee speed={35} gradient={false} pauseOnHover>
                {t.marquee.concat(t.marquee).map((item, i) => (
                    <span key={i} className="mx-8 flex items-center gap-16">
                        <span className="font-display text-4xl md:text-6xl font-black tracking-tight text-outline whitespace-nowrap">
                            {item}
                        </span>
                        <span className="h-2 w-2 rotate-45 bg-cyan-400/60" />
                    </span>
                ))}
            </FastMarquee>
        </div>
    );
};
